// require("./foreach-polyfil/foreach-polyfil.js"); 
// require('../node_modules/scopedQuerySelectorShim/src/scopedQuerySelectorShim.js');

var SimpleLightbox = require('simple-lightbox');
// var objectFitImages = require('object-fit-images');

import { toggle } from "./toggle/toggle.js";
import { multilevel } from "./multilevel-nav/multilevel-nav.js";
import { windowheight } from "./windowheight/windowheight.js";
import LazyLoad from "vanilla-lazyload"; 
import CookiesEuBanner from "../node_modules/cookies-eu-banner/dist/cookies-eu-banner.js";

// Simple Lightbox
var lightbox = new SimpleLightbox({elements: '.imageGallery1 a'});

SimpleLightbox.defaults = {
    loadingCaption: '',
    elementLoadingClass: '',
    loadingTimeout: 100000,
}


document.querySelector('.lightbox-close').addEventListener('click', function(e) {
        e.preventDefault();
        lightbox.close();
});

// new CookiesEuBanner(function () {
//     console.log('Cookies Enabled');
//     console.log('Google Analytics Enabled');
//     console.log('Google Tag Manager Enabled');

//     // (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-WQRSSVX');
    
//     // window.dataLayer = window.dataLayer || [];
//     // function gtag(){dataLayer.push(arguments);}
//     // gtag('js', new Date());
//     // gtag('config', 'UA-177506867-1');
  
// }, true);

new CookiesEuBanner(function () {
   
}, true);


// // Object Fit Images
// objectFitImages();


var areClipPathShapesSupported = function () {

    var base = 'clipPath',
        prefixes = [ 'webkit', 'moz', 'ms', 'o' ],
        properties = [ base ],
        testElement = document.createElement( 'testelement' ),
        attribute = 'polygon(50% 0%, 0% 100%, 100% 100%)';

    // Push the prefixed properties into the array of properties.
    for ( var i = 0, l = prefixes.length; i < l; i++ ) {
        var prefixedProperty = prefixes[i] + base.charAt( 0 ).toUpperCase() + base.slice( 1 ); // remember to capitalize!
        properties.push( prefixedProperty );
    }

    // Interate over the properties and see if they pass two tests.
    for ( var i = 0, l = properties.length; i < l; i++ ) {
        var property = properties[i];

        // First, they need to even support clip-path (IE <= 11 does not)...
        if ( testElement.style[property] === '' ) {

            // Second, we need to see what happens when we try to create a CSS shape...
            testElement.style[property] = attribute;
            if ( testElement.style[property] !== '' ) {
                return true;
            }
        }
    }

    return false;
};


if(!!window.MSInputMethodContext && !!document.documentMode) {
    var imgEl = document.getElementsByTagName('img');
    for (var i=0; i<imgEl.length; i++) {
        if(imgEl[i].getAttribute('data-srcset')) {
        imgEl[i].setAttribute('src',imgEl[i].getAttribute('data-srcset'));
        imgEl[i].removeAttribute('data-srcset'); //use only if you need to remove data-src attribute after setting src
        }
    }

    var mainestatemap = document.querySelector('[src="https://mountducap.com/wp-content/uploads/2020/10/main-estate-map.svg"]');

    mainestatemap.setAttribute('src', 'https://mountducap.com/wp-content/themes/wordpress-theme-mount-du-cap/static/../static/svg/main-estate-map.svg' + '-support.svg');
}


if(window.innerWidth > '576') {

    let getPhoneNumbers = document.querySelectorAll('.kl-phone');

    getPhoneNumbers.forEach(function (elem, index) {
        elem.addEventListener('click', function(e) {
            e.preventDefault();
        });
    });
}


function scroller() {

    let headerbarsqa = document.querySelectorAll('.header-bar');
    let qsa = document.querySelectorAll('.atom-image');

    let scrollpos = null;
    let headeritem = null;
    let itemmin, itemmax, flag;
    let toggleitems = null;



        ['load','resize','scroll'].forEach(  evt => 
            window.addEventListener(evt, () => {

        scrollpos = window.scrollY;

        headerbarsqa.forEach(function(headerbaritem, index) {
            flag = 0;
            toggleitems = headerbaritem.querySelectorAll('.toggle-items');

            qsa.forEach(function(item, index) {
            
                itemmin = item.getBoundingClientRect().top;
                itemmax = item.getBoundingClientRect().top + item.offsetHeight;
                headeritem = (84 / 2);

                if(headeritem > itemmin && headeritem < itemmax ) {
            
                    flag = 1;
                } 
            });

            if(flag == 1) {
            toggleitems.forEach(function(toggle, index) {
                headerbaritem.classList.add('active');
                toggle.classList.add('active');
            });
            } else {
                toggleitems.forEach(function(toggle, index) {
                    headerbaritem.classList.remove('active'); 
                    toggle.classList.remove('active');
                });
            }
        });

            })

        )

  
}




let Multilevel = new multilevel('.menu, .sub-menu');

let toggleInstance = new toggle( 'data-link', 'data-target', 'target-active' );
let WindowHeight = new windowheight();



function fixFloat(link, target, active) {

    let elems = document.querySelectorAll('[' + link + ']');

    elems.forEach(function (elem, index) {
        ['load','resize', 'scroll'].forEach(  evt => 

            window.addEventListener(evt, () => {

                let tgts = document.querySelectorAll('[data-heighttarget="' + elem.dataset.heightlink + '"]');
             
                
                tgts.forEach(function (tgt, index) {

                    if(window.innerWidth > '576') {
                    
                        if(elem.dataset.status != 'set') {
                            if(elem.getBoundingClientRect().top > tgt.getBoundingClientRect().top + 1) {
                                elem.style.setProperty('position', 'static');
                                tgt.style.setProperty('position', 'absolute');
                                elem.style.setProperty('transform', 'translateY(0)');
                                elem.setAttribute('data-status', 'set');
                                elem.setAttribute('data-pos', window.scrollY);

                                console.log('above');
                            } 
                        }
                        
            

                        if(elem.dataset.status == 'set' && window.scrollY < elem.dataset.pos) {
                            elem.style.setProperty('position', 'fixed');
                            elem.style.setProperty('transform', 'translateY(-50%)');
                            tgt.style.setProperty('position', 'static');
                            elem.removeAttribute('data-status');

                        }


                    } else {
                        elem.style.removeProperty('position');
                        tgt.style.removeProperty('position');
                        elem.style.removeProperty('transform');
                    }

                    tgt.style.setProperty('height', parseInt((elem.getBoundingClientRect().height)) + 'px');
                },  { passive: true });
            }, { passive: true })
        );
    });

}




document.querySelectorAll('.banner-scroller').forEach(btn => {
    btn.addEventListener('click', function(e) {
        e.preventDefault();

      let scrollDistance = document.documentElement.clientHeight;
      if (btn.className.split(' ').includes('scroll-up')) {
        scrollDistance *= -1;
      }
      window.scrollBy({
          top: scrollDistance,
          behavior: 'smooth',
      });
    });
  });


function effect_object_fixed_out() {

    let elems = document.querySelectorAll('.effect-object-fixed-out');
    let tgt;

    elems.forEach(function (elem, index) {
        ['load','resize','scroll'].forEach(  evt => 
            window.addEventListener(evt, () => {

                tgt = elem.querySelector('.overlay-container > div');

                if(window.innerWidth > '576') {

                    if(elem.getBoundingClientRect().top < 0) {
                        
                        tgt.style.setProperty('position', 'fixed');
                        tgt.style.setProperty('top', '50%');
                        tgt.style.setProperty('z-index', '1');
                        tgt.style.setProperty('transform', 'translateY(-50%)');
                    } else {
                        tgt.style.removeProperty('position');
                        tgt.style.removeProperty('top');
                        tgt.style.removeProperty('transform');
                    }

                    console.log((window.outerHeight / 2));

                    if(elem.getBoundingClientRect().top < -(window.outerHeight / 2)) {
                        tgt.style.setProperty('opacity', '0');
                        tgt.style.setProperty('top', '-9999px');
                    } else {
                        tgt.style.setProperty('opacity', '1');
                    }

                } else {
                    tgt.style.removeProperty('position');
                    tgt.style.removeProperty('top');
                    tgt.style.removeProperty('transform');
                    tgt.style.setProperty('opacity', '1');
                }
                

            })
        );
    });

}

function effect_object_fixed_in() {

let elems2 = document.querySelectorAll('.effect-object-fixed-in');
let tgt2;

elems2.forEach(function (elem, index) {

    ['load','resize','scroll'].forEach(  evt => 

        window.addEventListener(evt, () => {

            tgt2 = elem.querySelector('.overlay-container > div');

            if(window.innerWidth > '576') {

                tgt2.style.setProperty('position', 'fixed');
                tgt2.style.setProperty('opacity', '0');
                tgt2.style.setProperty('top', '-99999px');
                tgt2.style.setProperty('transform', 'translateY(-50%)');


                if(elem.getBoundingClientRect().top < (window.outerHeight / 2) - 100) {
                    tgt2.style.setProperty('opacity', '1');
                    tgt2.style.setProperty('top', '50%');
                }


                if(elem.getBoundingClientRect().top < 0) {
                    tgt2.style.removeProperty('position');
                    tgt2.style.setProperty('opacity', '1');
                    tgt2.style.removeProperty('top');
                    tgt2.style.removeProperty('transform');
       
                } 

            } else {
                tgt2.style.removeProperty('position');
                tgt2.style.setProperty('opacity', '1');
                tgt2.style.removeProperty('top');
                tgt2.style.removeProperty('transform');
            }


        })
    );
});

}




const globalUrl = 'https://mountducap.com';




var myLazyLoad = new LazyLoad(); 

myLazyLoad.update();


function init() {
    myLazyLoad.update();

    alwaysInit();
}


function artificialLink() {
    let link = document.querySelectorAll('.link');
    let reference;

    link.forEach(function (elem, index) {

        ['click'].forEach(  evt => 

            elem.addEventListener(evt, (action) => {


                reference = elem.querySelector('a');

                
                window.location.href = reference.href;

            })
        );
    });
}


alwaysInit();

// if(swup.cache.getPage(globalUrl + '/')) {
//     swup.preloadPage(globalUrl);
// }

function alwaysInit() {
    
    setTimeout(function(){ 
        effect_object_fixed_in();
        effect_object_fixed_out();

        variableChange('[local-time]', getGmtDate( -4 ));
        
        weatherBalloon( 'Castries,St Lucia' );

        fixFloat('data-heightlink', 'data-heighttarget', 'active' );
        scroller();
        mapBehaviour();

        artificialLink();

    }, 250);

}



export function main() {    
    return (
        console.log('Astridr JS Started')
    );
}


let mimic = document.querySelectorAll('.mimic');


function nativeSelector() {
    var elements = document.querySelectorAll("body, body *");
    var results = [];
    var child;
    for(var i = 0; i < elements.length; i++) {
        child = elements[i].childNodes[0];
        if(elements[i].hasChildNodes() && child.nodeType == 3) {
            results.push(child);
        }
    }
    return results;
}



function getGmtDate( hoursAdjust ) {
    let hours = new Date().getUTCHours();
    let min = new Date().getUTCMinutes();

    console.log(hours);
    console.log(hoursAdjust);

    if(hours < 10) {
        if(hours < 0) {
            hours = '0' - (hours - Math.abs(hoursAdjust));
        }
        if(hours > 0) {
            hours = '0' - (hours + Math.abs(hoursAdjust));
        }
    } else {
        if(hours < 0) {
            hours = (hours - Math.abs(hoursAdjust));
        }
        if(hours > 0) {
            hours = (hours - Math.abs(hoursAdjust));
        }
    }

    if(min < 10) {
        min = '0' + min;
    }

    return hours + ':' + min;
}



function variableChange(oldChange, newChange) {
    let textnodes = nativeSelector(),
    _nv;

    for (var i = 0, len = textnodes.length; i<len; i++){
        _nv = textnodes[i].nodeValue;
        textnodes[i].nodeValue = _nv.replace(oldChange, newChange);
    }
}


function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

function weatherBalloon( cityID ) {
    var key = 'f5805a914d7e68cb485104663b0bf9c6';
    var key = '417a0545b5366ccbbe3cc805e9e5fe90';

    fetch('https://api.openweathermap.org/data/2.5/weather?q=' + cityID + '&appid=' + key)  
    .then(function(resp) { return resp.json() }) // Convert data to json
    .then(function(data) {

 
        let newTemp = round((data.main.temp -  273.15), 0) + 'ᴼC / ' +  round((data.main.temp - 273.15) * (9/5) + 32, 0) + 'ᴼF';

        variableChange('[weather-temp]', newTemp);
    })
    .catch(function() {
      // catch any errors
    });
  }
  







function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}


function mapBehaviour() {

    var mapMarker = document.querySelectorAll('.mapmarker, .mapmarker-textonly');
    var mappos = document.querySelectorAll('.mappos');
    let i;

    if(window.innerWidth < '576') {
        for (i = 0; i < mapMarker.length; i++) {
            mapMarker[i].addEventListener('click', function(event) {
                event.preventDefault();
            });
        }

        for (i = 0; i < mappos.length; i++) {
            mappos[i].addEventListener('click', function(event) {
                event.preventDefault();
            });
        }
    }
   
}



if(document.querySelector('.masterplan')) {
    let qsa = document.querySelectorAll('.masterplan .molecule-estate-map a');

    let existingNode = document.querySelector('.masterplan .overlay .line');
    let newNode = document.createElement("span");
    newNode.className = "font font70 fontlight script newtitle";
    insertAfter(newNode, existingNode);



    existingNode = document.querySelector('.masterplan .overlay .kl-bullet-points');
    newNode = document.createElement("a");
    newNode.textContent = 'VIEW PLOT';
    newNode.className = "kl-button font41 fontbold kl-button-light hide-mobile hide-desktop hide-tablet";
    insertAfter(newNode, existingNode);

 

    qsa.forEach(function (elem, index) {

        ['click'].forEach(  evt => 

            elem.addEventListener(evt, (action) => {
                action.preventDefault();

                if(window.innerWidth > '576') {
                    document.querySelector('.masterplan .overlay .right .kl-button').classList.remove('hide-desktop');
                    document.querySelector('.masterplan .overlay .right .kl-button').classList.remove('hide-tablet');

                    if(elem.dataset.mapid == '88' || elem.dataset.mapid == 88) {
                        document.querySelector('.masterplan .overlay .right .kl-button').href = "https://mountducap.com/private-estate";
                    } else {
                        document.querySelector('.masterplan .overlay .right .kl-button').href = "https://mountducap.com/home-plots/plot-" + elem.dataset.mapid;
                    }

                    document.querySelector('.masterplan .overlay .right .newtitle').textContent = "Plot " + elem.dataset.mapid;

                    getDisplacedContent_map1(elem);

                    console.log(action.target.parentNode);
    
                    let permhover = document.querySelectorAll('.permhover');
                    permhover.forEach(function (permelem, index) {
                        permelem.classList.remove('permhover');
             
                    });
    
                    if(action.target.classList.contains('mapmarker')) {
                        action.target.previousSibling.previousSibling.classList.add("permhover");
                    }
    
                    if(action.target.parentNode.classList.contains('mapmarker')) {
                        action.target.parentNode.previousSibling.previousSibling.classList.add("permhover");
                    }

                    elem.classList.add('permhover');


                    
                } 
            
               
            })

        )

    });

    
};



// Force Script to be ready
setTimeout(() => {
    let qsaChosenResult = document.querySelector('.chosen-container');
    if(qsaChosenResult) {
        qsaChosenResult.addEventListener('click', function() {
            let qsaActiveResult = document.querySelectorAll('.active-result');
            qsaActiveResult.forEach(function (elem, index) {
                ['click'].forEach(  evt => 
                        elem.addEventListener(evt, (action) => {
                            qsaChosenResult.classList.remove('chosen-with-drop');
                            qsaChosenResult.classList.remove('chosen-container-active');
                    })
                )
            });
        });
    }
}, 1);